import { isOverBaseLine, validURL, validEmail, validateCellphone, validateBusinessLicenseImgNum, validateBankCardNum, validateName , positiveNum, twoDecimal, maxNum} from '@/utils/validate'

/**
 * 验证邮箱
 * @param rule
 * @param value
 * @param callback
 */
export function isEmail(rule, value, callback) {
    if (validEmail(value)) {
        callback()
    } else {
        callback(new Error('请输入正确的邮箱地址'))
    }
}

/**
 * 验证手机号码
 * @param rule
 * @param value
 * @param callback
 */
export function isCellphone(rule, value, callback) {
    if (validateCellphone(value)) {
        callback()
    } else {
        callback(new Error('请输入正确的手机号码'))
    }
}

/**
 * 验证网址
 * @param rule
 * @param value
 * @param callback
 */
export function isURL(rule, value, callback) {
    if (validURL(value)) {
        callback()
    } else {
        callback(new Error('请输入正确的网址'))
    }
}

/**
 * 验证统一社会信用代码
 * @param rule
 * @param value
 * @param callback
 */
export function isBusinessLicenseImgNum(rule, value, callback) {
    if (value == "" || validateBusinessLicenseImgNum(value)) {
        callback()
    } else {
        callback(new Error('请输入正确的统一社会信用代码'))
    }
}

/**
 * 验证公司简称码
 * @param rule
 * @param value
 * @param callback
 */
export function isPartyGroupPrefix(rule, value, callback) {
    const reg = /^[A-Z]{2,6}$/
    if (reg.test(value)) {
        callback()
    } else {
        callback(new Error('请输入2-6位大写字母'))
    }
}

/**
 * 大写字母校验
 * @param rule
 * @param value
 * @param callback
 */
export function isABC(rule, value, callback) {
    const reg = /^[A-Z]+$/
    if (reg.test(value)) {
        callback()
    } else {
        callback(new Error('请输入大写字母'))
    }
}
export function is2ABC(rule, value, callback) {
    const reg = /^[A-Z]{2}$/
    if (reg.test(value)) {
        callback()
    } else {
        callback(new Error('请输入2位大写字母'))
    }
}
export function is4ABCorNum(rule, value, callback) {
    const reg = /^[A-Z0-9]{2,4}$/
    if (reg.test(value)) {
        callback()
    } else {
        callback(new Error('请输入2~4位大写字母或数字'))
    }
}
//判断金额
export function mayDecimal(rule, value, callback) {
    let reg = /(^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$)/;
    if (value > 1000000000) {
        callback(new Error('输入数字过大'))
    }
    if (reg.test(value) || value === '') {
        callback()
    } else {
        callback(new Error('请输入正确的格式(保留两位小数)'))
    }
}
// 判断最大输入数字
export function maxNumber(rule, value, callback) {
    if (value > 1000000000) {
        callback(new Error('输入数字过大'))
    } else {
        callback()
    }
}
//判断正整数和0
export function isPositiveInteger(rule, value, callback) {
    const reg = /^[0-9]\d*$/;
    if (reg.test(value) || !value) {
        callback()
    } else {
        callback(new Error('请输入正整数'))
    }
}
//判断正整数
export function isInteger(rule, value, callback) {
    const reg = /^[1-9]\d*$/;
    if (reg.test(value) || value === '' || value === undefined) {
        callback()
    } else {
        callback(new Error('请输入正整数'))
    }
}
//
// 限定长度为10位数或者18位
export function istenOrEighteen(rule, value, callback) {
    if (!value) return callback();
    if (value.length == 10 || value.length == 18) {
        callback()
    } else {
        callback(new Error('请输入10位或者18位社会统一代码'))
    }
}

//验证数字输入框最大数值,32767
export function checkMaxVal(rule, value, callback) {
    if (value < 0 || value > 99999999.99) {
        callback(new Error('请输入[0,99999999.99]之间的数字'));
    } else {
        callback();
    }
}
//判断正整数和0
export function ishundredInteger(rule, value, callback) {
    let reg = /^(?:[1-9]?\d|100)$/;
    if (reg.test(value) || value === '') {
        callback()
    } else {
        callback(new Error('请输入0-100正整数'))
    }
}
//判断0-100之间的数字
export function isBetweenHundred(rule, value, callback) {
    let reg = /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/;
    if (reg.test(value) || value === '') {
        callback()
    } else {
        callback(new Error('请输入0-100的数字(保留两位小数)'))
    }
}

//判断金额格式，小数点后只能输入2位小数，0只有金额小于1时才能作为首字母
export function isFixed2(rule, value, callback) {
    let reg = /^([1-9]\d*|0)(\.\d{1,2})?$/;
    if (value > 1000000000) {
        callback(new Error('输入金额过大'))
    }
    if (reg.test(value) || value === '') {
        callback()
    } else {
        callback(new Error('请输入正确的格式(保留两位小数)'))
    }
}
// 判断字符串大于0
export function gtZero2(rule, value, callback) {
  value = parseFloat(value).toFixed(2)
  if (value > 0) {
      callback()
  } else {
      callback(new Error('请输入大于0的数字'))
  }
}

/**
 * 检查密码
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export function checkPassword(rule, value, callback) {
    if (!value || (value.length >= 8 && isOverBaseLine(value))) {
        callback()
    } else {
        callback(new Error('8位密码,数字，字母，特殊字符至少有两种'))
    }
}
/**
 * 是否银行卡号
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export function isBankCardNum(rule, value, callback) {
    if (validateBankCardNum(value)) {
        callback()
    } else {
        callback(new Error('银行卡号输入错误'))
    }
}

export function isBankAssociationNumber(rule, value, callback) {
    const reg = /^[1-9]{1}\d{11}$/;
    if (reg.test(value) || value === '' || value === undefined) {
        callback()
    } else {
        callback(new Error('请输入12位联行行号'))
    }
}

/**
 * 验证人名
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export function isPersonName(rule, value, callback) {
    if (value === '' || value === undefined || validateName(value)) {
        callback()
    } else {
        callback(new Error('只能输入中文、英文和中文点(·)'))
    }
}
//小数点前20位，小数点后6位,不为0的20位整数验证    目前改成2位
export function isFixed6(rule, value, callback) {
    // let reg = /^0(\.[0-9]{1,2})*$|^[1-9]\d{0,19}(\.\d{1,2})*$/;
    let reg = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,19}\.\d{0,2}$|^[1-9]\d{0,19}$/;
    if (reg.test(value) || value === '') {
        callback()
    } else {
        callback(new Error('请输入正确格式'))
    }
}
//判断是否数字
export function isNumber(rule, value, callback) {
    const reg = /^[0-9]\d*$/;
    if (reg.test(value) || !value) {
        callback()
    } else {
        callback(new Error('请输入数字'))
    }
}

/**
 * 金额
 * 必填/非必填 正数 小数点后两位 限制最大数字
 * @param rule
 * @param value
 * @param callback
 */
 export function isFixed2New(rule, value, callback) {
	if (rule.required && (value === '' || value === undefined)) {
		callback(new Error('请输入数字'))
	} else if (!positiveNum(value)) {
		callback(new Error('请输入正数'))
	} else if (!twoDecimal(value)) {
		callback(new Error('请最多保留两位小数'))
	} else if (!maxNum(value)) {
		callback(new Error('数字过大'))
	} else {
		callback()
	}
}
